<template>
    <div class="mysection">
        <div class="mine_head">
          <div class="mine_head_left">
            <img :src="'data:image/jpg;base64,'+webUser.headimgurl"/>
             <h4>{{this.b64DecodeUnicode(webUser.nickname)}}</h4>
            <p>{{webUser.phoneNumber}}</p>
          </div>
          <div class="mine_head_right">
            <a v-on:click="toQRCode" v-if="webUser.type==='1'" v-loading.fullscreen.lock="fullscreenLoading" element-loading-spinner="el-icon-loading"
               element-loading-background="rgba(255, 255, 255, 1)" element-loading-text="加载中,请稍后" >
                <i class="iconfont right">&#xe642;</i>
                <i class="iconfont qrcode">&#xe693;</i>
            </a>
          </div>
        </div>

        <div class="mybtn_group">
            <a v-on:click="toUserInfo">个人资料<i class="iconfont right">&#xe642;</i></a>
            <a v-if="webUser.type==='1'" v-on:click="toWxMyCustomer">我的客户<i class="iconfont right">&#xe642;</i><span>{{wxMyCustomerCount}}</span></a>
        </div>
        <div class="mybtn_group">
            <a v-on:click="toMyborrow">我的借入<i class="iconfont right">&#xe642;</i><span>{{wxMyBorrowCount}}</span></a>
            <a v-on:click="toMyloan">我的出借<i class="iconfont right">&#xe642;</i><span>{{wxMyLoanCount}}</span></a>
            <a v-on:click="toMyAssignmentDebt">债权转让<i class="iconfont right">&#xe642;</i><span>{{wxMyAssignmentCount}}</span></a>
        </div>
        <div class="mybtn_group">
            <a v-on:click="toMyPassword">修改密码<i class="iconfont right">&#xe642;</i></a>
        </div>
      <div class="btn_large padding_top">
        <el-button type="danger" size="large" @click="toExit">退出</el-button>
      </div>

    </div>
</template>
<script>
   import {reqWebUserOne,reqWxMyLoanCount,reqWxMyBorrowCount,reqWxMyAssignmentDebtCount,reqWxMyCustomCount} from '../../api/weixin-api'
    export default {
        data () {
            return {
              webUser:{},
              wxMyLoanCount:0,
              wxMyBorrowCount:0,
              wxMyAssignmentCount:0,
              wxMyCustomerCount:0,
              fullscreenLoading:false,
            }
        },
        methods:{
            toUserInfo:function () {
                this.$router.push({path:'wxuserInfo',query:{id:this.webUser.id}});
            },
          toWxMyCustomer:function () {
            this.$router.push({path:'wxMyCustomer',query:{id:this.webUser.id}});
          },
            toMyborrow:function () {
                this.$router.push({path:'wxmyborrow',query:{userId:this.webUser.id}});
            },
            toMyloan:function () {
                this.$router.push({path:'wxmyloan',query:{userId:this.webUser.id}});
            },
            toMyAssignmentDebt:function () {
                this.$router.push({path:'wxmyAssignmentDebt',query:{userId:this.webUser.id}});
            },
            toMyPassword:function () {
                this.$router.push({path:'wxmyPassword',query:{id:this.webUser.id}});
            },
          toExit(){
            var that=this;
            that.$confirm('确认退出?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              window.localStorage.removeItem("Authorization");
              that.$router.push({path:'/wxLogin'});
            }).catch(() => {
            });
          },
          toQRCode:function () {
            this.fullscreenLoading = true;
            setTimeout(() => {
              this.fullscreenLoading = false;
              this.$router.push({path:'wxmyQRCode',query:{id:this.webUser.id}});
            }, 2000)
            },
          show_userInfo_byType(token){
            reqWebUserOne({id:token}).then((res)=>{
                if(res.data.code===1){
                  this.webUser=res.data.data
                }else {
                  this.webUser={};
                }
              })
          },
          show_wxMyLoanCount(token){
            reqWxMyLoanCount({userId:token}).then((res)=>{
              if(res.data.code===1){
                this.wxMyLoanCount=res.data.data.wxTotals
              }else {
                this.wxMyLoanCount=0;
              }
            })
          },
          show_wxMyBorrowCount(token){
            reqWxMyBorrowCount({userId:token}).then((res)=>{
              if(res.data.code===1){
                this.wxMyBorrowCount=res.data.data.wxTotals
              }else {
                this.wxMyBorrowCount=0;
              }
            })
          },
          show_wxMyAssignmentDebtCount(token){
            reqWxMyAssignmentDebtCount({userId:token}).then((res)=>{
              if(res.data.code===1){
                this.wxMyAssignmentCount=res.data.data.wxTotals
              }else {
                this.wxMyAssignmentCount=0;
              }
            })
          },
          show_wxMyCustomCount(token){
            reqWxMyCustomCount({userId:token}).then((res)=>{
              if(res.data.code===1){
                this.wxMyCustomerCount=res.data.data
              }else {
                this.wxMyCustomerCount=0;
              }
            })
          },
          isWechatBrowser: function () {
            let that=this;
            let ua = navigator.userAgent.toLowerCase();
            let isWeixin = ua.indexOf('micromessenger') !== -1;
            if (!isWeixin) {
              that.$router.push({name: 'wxError'});
            }
          },
          backWeiXin:function() {
            pushHistory();

            function bodyScroll() {
              var state = {
                title: "title",
                url: ""
              };
              window.history.pushState(state, state.title, state.url);
//              window.location.href ='/wxMyHomePage';
            }

            window.addEventListener("popstate", bodyScroll, false)
            function pushHistory() {
              var state = {
                title: "title",
                url: ""
              };
              window.history.pushState(state, state.title, state.url);
            }

          },
// 微信头像解码
          b64DecodeUnicode(str) {
            return decodeURIComponent(atob(str).split('').map(function(c) {
              return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));
          }

        },
        mounted(){
            this.$store.dispatch('hideHF');
          var row=this.$route.query;
            this.backWeiXin();
            this.isWechatBrowser();
//          注册用户 zp
//            var token="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJwaGpkLWF1dGhvcml6YXRpb24iLCJpc3MiOiJwaGpkLXhpYW4iLCJleHAiOjE1MzI2NjQ1MjksInVzZXJJZCI6IjQ4Njk3M2M0NThlNzQwZTU5YjBjYzNmOGViODg0NzVmIiwiaWF0IjoxNTMyMDU5NzI5LCJ1c2VybmFtZSI6InpwIn0.hKCEUWcUqzP2AxUcvlWdEf_jDtA8jAk0kqns57lXViU";
//          业务员  zhangsan
//            var token="eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJwaGpkLWF1dGhvcml6YXRpb24iLCJpc3MiOiJwaGpkLXhpYW4iLCJleHAiOjE1MzQzMjc5NzksInVzZXJJZCI6IjMzMzZhMGU5MzVjYjRjMjg4NmUzNWQ5YWFkYmM0ODA2IiwiaWF0IjoxNTMzNzIzMTc5LCJ1c2VybmFtZSI6IjExMSJ9.uqvWr_EETqAsCiEBs70etHLqzDumqX6tlZikogMWCAk";
            var token=  localStorage.getItem("Authorization");
            console.info("===token===="+token);
            this.token=token;
          if(token){
             this.token=token;
             this.show_userInfo_byType(token);
             this.show_wxMyLoanCount(token);
             this.show_wxMyBorrowCount(token);
             this.show_wxMyAssignmentDebtCount(token);
             this.show_wxMyCustomCount(token);
             }
            console.info("================进入用户中心获取token========="+token);

        }
    }
</script>
<style slot-scope="scope">
  @import '../../assets/css/wxstyle.css';
</style>




// WEBPACK FOOTER //
// src/components/weChat/WxMyHomePage.vue